import EFOcats_validates from '../../../core/v2/validate/efocats_validates.js';
import EFOcats_curves_validate_hiragana from './efocats_curves_validate_hiragana.js';

export default class EFOcats_curves_validates extends EFOcats_validates {
  constructor() {
    super();
    this.hiragana = new EFOcats_curves_validate_hiragana();
  }
}
